import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import SubmissionDetailsPage from '../components/submissions/SubmissionDetailsPage';
import LoadingSpinner from '../components/ui/LoadingSpinner';

const SubmissionDetails = () => {
  const { submissionId } = useParams();

  // Redirect to home if no submission ID
  if (!submissionId) {
    return <Navigate to="/" replace />;
  }

  return <SubmissionDetailsPage />;
};

export default SubmissionDetails;
